import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M4.633 4.633C3.754 5.513 3.371 7.07 3.371 10s.383 4.488 1.262 5.367c.88.879 2.436 1.262 5.367 1.262s4.488-.383 5.367-1.262c.879-.88 1.262-2.436 1.262-5.367s-.383-4.487-1.262-5.367c-.88-.879-2.436-1.262-5.367-1.262s-4.487.383-5.367 1.262m-.97-.97C4.98 2.349 7.08 2 10 2s5.021.348 6.336 1.664S18 7.079 18 10c0 2.92-.349 5.021-1.664 6.336S12.921 18 10 18c-2.92 0-5.021-.349-6.336-1.664S2 12.921 2 10c0-2.92.348-5.021 1.664-6.336M9.56 6.922a2.311 2.311 0 1 1 .439 4.577.686.686 0 1 1 .004-1.371.94.94 0 0 0 .43-1.777h-.002a.924.924 0 0 0-1.126.225.686.686 0 0 1-1.046-.886 2.3 2.3 0 0 1 1.3-.768M10 12.565c.379 0 .686.307.686.686v.008a.686.686 0 0 1-1.372 0v-.008c0-.379.307-.686.686-.686",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }